<template>
  <div>
    <div v-if="page.state != 'rendered'">
      <v-progress-circular indeterminate color="primary">
      </v-progress-circular>
    </div>
    <PDFCanvasV3 v-if="shouldRender" :page="page" />
  </div>
</template>

<script>
import { mapState } from "vuex";

import PDFCanvasV3 from "./PDFCanvasV3.vue";

export default {
  name: "PDFPageV3",
  props: {
    page: {
      type: Object, // instance containing an instance of  PDFPageProxy returned from pdf.getPage
      required: true,
    },
  },
  components: {
    PDFCanvasV3,
  },
  data() {
    return {
      top: undefined,
      bottom: undefined,
      visible: true,
    };
  },
  computed: {
    ...mapState("pdf_data", ["defaultWidth", "defaultHeight"]),
    shouldRender() {
      return ["downloaded", "rendering", "rendered"].includes(this.page.state);
    },
  },
  mounted() {
    document.body.classList.add('overflow-hidden');
  },
};
</script>

<style scoped>
</style>
